import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

type ErrorDialogProps = {
  open: boolean;
  title: string;
  description: string;
  instruction?: string;
  onClose: () => void;
  onRetry?: () => void;
  retryText?: string;
  onCopyError?: () => void;
  copyText?: string;
};

export function ErrorDialog({
  open,
  title,
  description,
  instruction,
  onClose,
  onRetry,
  retryText,
  onCopyError,
  copyText,
}: ErrorDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-describedby="error-dialog-description"
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography id="error-dialog-description" variant="body1">
          {description}
        </Typography>
        {typeof instruction === "string" && instruction.length > 0 && (
          <Typography sx={{ mt: 2 }} variant="body2">
            {instruction}
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        {typeof onCopyError === "function" && (
          <Button onClick={onCopyError} variant="outlined">
            {copyText ?? t("common.actions.copy-error")}
          </Button>
        )}
        <Button
          onClick={() => {
            onRetry?.();
            onClose();
          }}
          variant="contained"
        >
          {retryText ?? t("common.actions.try-again")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ErrorDialog;
